import React, { useEffect, useState } from "react";
import { Alert } from "@material-ui/lab";
import { Snackbar, TextField } from "@material-ui/core";
import Select from "react-select";
import makeAnimated from "react-select/animated";
import axios from "axios";
import token from "../services/token";

const styles = {
  container: (base) => ({
    ...base,
    flex: 1,
  }),
};
const AddColis = ({
  colisInformations,
  setColisInformations,
  selectedGouvernerat,
  setSelectedGouvernerat,
  selectedVille,
  setSelectedVille,
  selectedValueAutorisation,
  setSelectedValueAutorisation,
  selectedValueEchange,
  setSelectedValueEchange,
  selectedValueFragile,
  setSelectedValueFragile,
  selectedValueModalite,
  setSelectedValueModalite,
  designationProduct,
  nbproducts,
}) => {
  const animatedComponents = makeAnimated();
  //select Gouvernerat
  // const [allGouvernerat, setAllGouvernerat] = useState([]);

  const [allGouvernerat, setAllGouvernerat] = useState([
    { label: "Ariana", value: "2080" },
    { label: "Béja", value: "9000" },
    { label: "Ben Arous", value: "2013" },
    { label: "Bizerte", value: "7000" },
    { label: "Gabès", value: "6000" },
    { label: "Gafsa", value: "2100" },
    { label: "Jendouba", value: "8100" },
    { label: "Kairouan", value: "3100" },
    { label: "Kasserine", value: "1200" },
    { label: "Kébili", value: "4200" },
    { label: "La Manouba", value: "2010" },
    { label: "Le Kef", value: "7100" },
    { label: "Mahdia", value: "5100" },
    { label: "Médenine", value: "4100" },
    { label: "Monastir", value: "5000" },
    { label: "Nabeul", value: "8000" },
    { label: "Sfax", value: "3000" },
    { label: "Sidi Bouzid", value: "9100" },
    { label: "Siliana", value: "6100" },
    { label: "Sousse", value: "4000" },
    { label: "Tataouine", value: "3200" },
    { label: "Tozeur", value: "2200" },
    { label: "Tunis", value: "1000" },
    { label: "Zaghouan", value: "1100" },
  ]);

  //select Ville
  // const cities = {
  //   Ariana: ["Ariana", "Raoued", "Kalaat El Andalous"],
  //   Béja: ["Béja", "Mateur", "Teboursouk"],
  //   "Ben Arous": ["Ben Arous", "Mohamedia", "Medina Jedida"],
  //   Bizerte: ["Bizerte", "Menzel Bourguiba", "Mateur"],
  //   Gabès: ["Gabès", "Ghannouch", "El Hamma"],
  //   Gafsa: ["Gafsa", "Metlaoui", "Mdhila"],
  //   Jendouba: ["Jendouba", "Bousalem", "Tabarka"],
  //   Kairouan: ["Kairouan", "El Alia", "Sbeitla"],
  //   Kasserine: ["Kasserine", "Thala", "Majel Bel Abbès"],
  //   Kébili: ["Kébili", "Douz", "Chébika"],
  //   "La Manouba": ["La Manouba", "Tebourba", "Bordj El Amri"],
  //   "Le Kef": ["Le Kef", "Sakiet Sidi Youssef", "El Kef"],
  //   Mahdia: ["Mahdia", "El Jem", "Hebira"],
  //   Médenine: ["Médenine", "Zarzis", "Ben Guerdane"],
  //   Monastir: ["Monastir", "Ksar es-Sid", "Sahline"],
  //   Nabeul: ["Nabeul", "Hammamet", "Kelibia"],
  //   Sfax: ["Sfax", "Kerkennah", "Mahrès"],
  //   "Sidi Bouzid": ["Sidi Bouzid", "Meknassy", "Cebbala"],
  //   Siliana: ["Siliana", "Bouarada", "Ksar es-Sid"],
  //   Sousse: ["Sousse", "Hammam Sousse", "Enfidha"],
  //   Tataouine: ["Tataouine", "Ghomrassen", "Remada"],
  //   Tozeur: ["Tozeur", "Nefta", "Dough"],
  //   Tunis: ["Tunis", "La Marsa", "Carthage"],
  //   Zaghouan: ["Zaghouan", "Zaghouan", "Saouaf"],
  // };
  // const [allVilles, setVilles] = useState([]);
  // const onChangeSelectVille = (item) => {
  //   setSelectedVille(item);
  // };
  const onChangeSelectGouvernerat = (item) => {
    setSelectedGouvernerat(item);
    // const selectedCities = cities[item?.label] || [];
    // const transformedCities = selectedCities.map((city) => ({
    //   label: city,
    //   value: city,
    // }));
    // setVilles(transformedCities);
  };
  ///**************checkbox buttons
  //checkbow button Autorisation

  //checkbow button Fragile
  const handleCheckboxChangeFragile = (value) => {
    setSelectedValueFragile((prevValue) => (prevValue === value ? "" : value));
  };

  const handleCheckboxChangeEchange = (value) => {
    setSelectedValueEchange((prevValue) => (prevValue === value ? "" : value));
  };

  const handleCheckboxChangeAutorisation = (value) => {
    setSelectedValueAutorisation((prevValue) =>
      prevValue === value ? "" : value
    );
  };

  const [allModalite, setAllModalite] = useState([
    { label: "Cheque", value: "0" },
    { label: "Espece", value: "2" },
    { label: "Aucun Preference", value: "3" },
  ]);
  // Handle checkbox change
  const handleCheckboxChangeModalite = (value) => {
    setSelectedValueModalite(value === selectedValueModalite ? "" : value);
  };
  ///**************/.checkbox buttons
  //alert
  const [openSuccessAlert, setOpenSuccessAlert] = useState(false);
  const [successAlertText, setSuccessAlertText] = useState("");
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState("");
  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };
  const handleSuccessClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenSuccessAlert(false);
  };
  // useEffect(() => {
  //   getModaliteListeByMassar();
  //   getcodesPostauxListByMassar();
  // }, []);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setColisInformations({ ...colisInformations, [name]: value });
  };

  // const getModaliteListeByMassar = () => {
  //   fetch(
  //     "https://corsproxy.io/?" +
  //       encodeURIComponent("https://my.massar.tn/API/modalite_liste")
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // console.log(data);
  //       setAllModalite(data);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };
  // const getcodesPostauxListByMassar = () => {
  //   fetch(
  //     "https://corsproxy.io/?" +
  //       encodeURIComponent("https://my.massar.tn/API/code_postal")
  //   )
  //     .then((response) => response.json())
  //     .then((data) => {
  //       // Transform the data to the desired format
  //       const postalCodes = Object.entries(data).map(([label, value]) => ({
  //         label,
  //         value: Number(value.replace(/"/g, "")),
  //       }));

  //       setAllGouvernerat(postalCodes);
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching data:", error);
  //     });
  // };

  return (
    <>
      <div className="card">
        <div className="card-header">
          <h3 className="card-title">Colis Informations</h3>
        </div>
        <div className="card-body">
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Nom/prénom</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="nom"
                  value={colisInformations?.nom || ""}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Numéro de Telephone</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="tel"
                  value={colisInformations?.tel || ""}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputGouvernerat">Gouvernerat</label>
                <Select
                  styles={styles}
                  closeMenuOnSelect={true}
                  components={animatedComponents}
                  defaultValue={selectedGouvernerat}
                  onChange={onChangeSelectGouvernerat}
                  options={allGouvernerat}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Ville</label>
                {/* <Select
                    styles={styles}
                    closeMenuOnSelect={true}
                    components={animatedComponents}
                    defaultValue={selectedVille}
                    onChange={onChangeSelectVille}
                    options={allVilles}
                  /> */}
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="ville"
                  value={colisInformations?.ville || ""}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Adresse</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="adresse"
                  value={colisInformations?.adresse || ""}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Désignation Produit</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="designation"
                  // disabled={true}
                  value={
                    colisInformations?.designation || designationProduct || ""
                  }
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">Montant à la reception (DT)</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="montant_reception"
                  value={colisInformations?.montant_reception || ""}
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">
                  Nombre de colis/Nombre de Pièces
                </label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="nombre_piece"
                  value={colisInformations?.nombre_piece || nbproducts || 0}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">référence colis</label>
                <input
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="reference"
                  value={
                    colisInformations?.reference || designationProduct || ""
                  }
                />
              </div>
            </div>
            <div className="col-sm-6">
              <div className="form-group">
                <label htmlFor="inputName">
                  {" "}
                  Autorisation d'ouveture du colis
                </label>
                <div className="row" style={{ marginTop: "8px" }}>
                  {["Oui", "Non"].map((option) => (
                    <div
                      className="col-12"
                      style={{
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      key={option}
                    >
                      <input
                        type="checkbox"
                        value={option}
                        checked={selectedValueAutorisation === option}
                        onChange={() =>
                          handleCheckboxChangeAutorisation(option)
                        }
                      />
                      <label
                        className="checkbox-label"
                        style={{ marginLeft: "8px" }}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-12">
              <div className="form-group">
                <label htmlFor="inputName">Contenu echange</label>
                <textarea
                  onChange={handleChange}
                  type="text"
                  id="inputName"
                  className="form-control"
                  name="contenuEchange"
                  value={colisInformations?.contenuEchange || ""}
                  rows={2}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Fragile</label>
                <div className="row" style={{ marginTop: "8px" }}>
                  {["Oui", "Non"].map((option) => (
                    <div
                      className="col-12"
                      style={{
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      key={option}
                    >
                      <div className="checkbox-container">
                        <input
                          type="checkbox"
                          value={option}
                          checked={selectedValueFragile === option}
                          onChange={() => handleCheckboxChangeFragile(option)}
                        />
                        <label
                          className="checkbox-label"
                          style={{ marginLeft: "8px" }}
                        >
                          {option}
                        </label>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Echange</label>
                <div className="row" style={{ marginTop: "8px" }}>
                  {["Oui", "Non"].map((option) => (
                    <div
                      className="col-12"
                      style={{
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                      key={option}
                    >
                      <input
                        type="checkbox"
                        value={option}
                        checked={selectedValueEchange === option}
                        onChange={() => handleCheckboxChangeEchange(option)}
                      />
                      <label
                        className="checkbox-label"
                        style={{ marginLeft: "8px" }}
                      >
                        {option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
            <div className="col-sm-4">
              <div className="form-group">
                <label htmlFor="inputName">Modalité</label>
                <div className="row" style={{ marginTop: "8px" }}>
                  {/* {Object.entries(allModalite).map(([key, label]) => ( */}
                  {allModalite.map((item) => (
                    <div
                      className="col-12"
                      key={item.value}
                      style={{
                        marginBottom: "8px",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <input
                        type="checkbox"
                        value={item.value}
                        checked={selectedValueModalite === item.value}
                        onChange={() =>
                          handleCheckboxChangeModalite(item.value)
                        }
                      />
                      <label
                        className="checkbox-label"
                        style={{ marginLeft: "8px" }}
                      >
                        {item.label}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Snackbar
        open={openSuccessAlert}
        autoHideDuration={2000}
        onClose={handleSuccessClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleSuccessClose} severity="success">
          {successAlertText}
        </Alert>
      </Snackbar>
      <Snackbar
        open={openErrorAlert}
        autoHideDuration={2000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert variant="filled" onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default AddColis;
